import React from 'react';

import {
  ESCs,
  FlightComputer,
  FlightControllers,
  HybridSeries,
  Simulator,
  MultiImage,
  ASDA,
  Contact,
} from 'modules/auvsi';

import motorsOne from '../../../main/assets/images/auvsi/motor-card-one.webp';
import motorsTwo from '../../../main/assets/images/auvsi/motor-card-two.webp';
import motorsThree from '../../../main/assets/images/auvsi/motor-card-three.webp';
import justiceCameraOne from '../../../main/assets/images/auvsi/justice-camera-one.webp';
import justiceCameraTwo from '../../../main/assets/images/auvsi/justice-camera-two.webp';
import justiceCameraThree from '../../../main/assets/images/auvsi/justice-camera-three.webp';
import justiceCameraFour from '../../../main/assets/images/auvsi/justice-camera-four.webp';
import dualCamOne from '../../../main/assets/images/auvsi/dualCam-one.webp';
import dualCamTwo from '../../../main/assets/images/auvsi/dualCam-two.webp';
import dualCamThree from '../../../main/assets/images/auvsi/dualCam-three.webp';
import hybridSeriesOne from '../../../main/assets/images/auvsi/hybrid-series-card-one.webp';
import hybridSeriesTwo from '../../../main/assets/images/auvsi/hybrid-series-card-two.webp';
import hybridSeriesThree from '../../../main/assets/images/auvsi/hybrid-series-card-three.webp';
import mrmOne from '../../../main/assets/images/auvsi/mrm-one.webp';
import mrmTwo from '../../../main/assets/images/auvsi/mrm-two.webp';
import mrmThree from '../../../main/assets/images/auvsi/mrm-three.webp';

const motors = [{ src: motorsOne }, { src: motorsThree }, { src: motorsTwo }];

const justiceCamera = [
  { src: justiceCameraOne },
  { src: justiceCameraTwo },
  { src: justiceCameraThree },
  { src: justiceCameraFour },
];

const dualCams = [
  { src: dualCamOne },
  { src: dualCamThree },
  { src: dualCamTwo },
];

const hybridSeries = [
  {
    imageSrc: hybridSeriesOne,
    subtitle: 'Orqa',
    title: 'IRONghost AU DSH 5W',
  },
  {
    imageSrc: hybridSeriesTwo,
    subtitle: 'Orqa',
    title: 'IRONghost AU QS 10W',
  },
  {
    imageSrc: hybridSeriesThree,
    subtitle: 'Orqa',
    title: 'IRONghost Vtx 4.9-6/10W Wing',
  },
];

const mrms = [
  {
    imageSrc: mrmOne,
    subtitle: 'Orqa',
    title: 'MRM2-10 S',
  },
  {
    imageSrc: mrmTwo,
    subtitle: 'Orqa',
    title: 'MRM2-10 F',
  },
  {
    imageSrc: mrmThree,
    subtitle: 'Orqa',
    title: 'MRM1-5',
  },
];

// mreza - opacity
export const Auvsi = () => {
  return (
    <section className="auvsi-section">
      <div className="auvsi-first-sticky-container">
        <FlightControllers />
        <ESCs />
      </div>
      <div className="auvsi-second-sticky-container">
        <FlightComputer />
        <MultiImage
          title="Orqa 2814 Brushless Motor"
          description="Custom Orqa motors, finely tuned for mission-critical performance, deliver unmatched power, reliability, and control for your FPV drone. Made in Croatia, EU."
          images={motors}
        />{' '}
        <MultiImage
          title="Orqa Justice FPV Camera"
          description="Low-latency, low-light analog FPV camera designed for high-performance unmanned systems. Made in Croatia, EU."
          images={justiceCamera}
        />{' '}
        <div style={{ paddingBottom: '32px' }}>
          <MultiImage
            title="Orqa MRM Dual Cam Kit"
            description="Upgrade your MRM sensor package with a perfectly calibrated dual-camera mount system, enabling reliable vision in the most demanding environments."
            images={dualCams}
          />{' '}
        </div>
      </div>
      <Simulator />
      <div className="auvsi-third-sticky-container">
        <HybridSeries
          sectionTitle="Hybrid series"
          sectionDescription="IRONGhost is a proprietary long-range control and video link designed for the most challenging environments and EW exposure. Its integrated high-power, wide-band video transmitter and off-band control links ensure reliable communication in the most adverse scenarios."
          cards={hybridSeries}
          increasedStrokeHeight
          secondItemIncreasedStroke
        />
        <HybridSeries
          sectionTitle="MRM system"
          sectionDescription="The MRM System is a complete, turnkey, end-to-end FPV-based versatile UAV system. It includes everything an operator needs to execute a wide variety of missions."
          cards={mrms}
          biggerImage
        />
      </div>
      <ASDA />
      <Contact />
    </section>
  );
};
